// extracted by mini-css-extract-plugin
export default {"cross":"styles_cross__9y-pF"};